import * as uuid from "uuid";
import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";
import {ShapeColorModel} from "../models/ShapeColor";
import {getFeatureNameById} from "../../../../helpers/featureHelper";

export class ShapeColorsController extends SQFTResourceController {

  defaultColorSets = [
    {
      id: uuid.v4(),
      primary: 'rgba(74, 144, 226, 0.17)',
      primary_border: '#4a90e2',
      primary_hover: 'rgba(61,115,173,0.33)',
    }, {
      id: uuid.v4(),
      primary: 'rgba(159, 197, 34, 0.17)',
      primary_border: '#9fc522',
      primary_hover: 'rgba(138,173,30,0.33)',
    }, {
      id: uuid.v4(),
      primary: 'rgba(201, 28, 123, 0.17)',
      primary_border: '#c91c7b',
      primary_hover: 'rgba(146,20,91,0.33)',
    }
  ]

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.shapeColors;
  }

  getShapeColorByFeatureId(featureId) {
    return this.getResources().find(resource => resource.featureId === featureId);
  }

  getOrGenerateNewShapeColorByFeatureId(featureId) {
    let colorSet = this.getShapeColorByFeatureId(featureId);
    if (!colorSet) {
      return this.createShapeColor(featureId);
    }
    return colorSet;
  }

  generateRandomRGB() {
    return {
      r: Math.floor(Math.random() * 256),
      g: Math.floor(Math.random() * 256),
      b: Math.floor(Math.random() * 256)
    };
  }

  darkenColor({r, g, b}, factor = 0.9) {
    return {
      r: Math.floor(r * factor),
      g: Math.floor(g * factor),
      b: Math.floor(b * factor)
    };
  }

  createShapeColor(featureId) {
    let colorSet = this.defaultColorSets.find(set => !this.getResourceById(set.id));
    if (!colorSet) {
      const baseColor = this.generateRandomRGB();
      const hoverColor = baseColor//this.darkenColor(baseColor);

      colorSet = {
        id: uuid.v4(),
        primary: `rgba(${baseColor.r}, ${baseColor.g}, ${baseColor.b}, 0.17)`,
        primary_border: `rgb(${baseColor.r}, ${baseColor.g}, ${baseColor.b})`,
        primary_hover: `rgb(${hoverColor.r}, ${hoverColor.g}, ${hoverColor.b}, 0.33)`
      };
    } else {
      this.defaultColorSets = this.defaultColorSets.filter(set => set.id !== colorSet.id);
    }

    const featureName = getFeatureNameById(featureId);

    const shapeColorModel = new ShapeColorModel(
      colorSet.id,
      featureId,
      featureName,
      colorSet.primary,
      colorSet.primary_border,
      colorSet.primary_hover
    );

    this.addResource(shapeColorModel);

    return shapeColorModel
  }
}
